import {
  withTranslation,
} from 'react-i18next';

import ChampionshipRegattasSectionView from './ChampionshipRegattasSectionView';

const TranslatedComponent = withTranslation()(ChampionshipRegattasSectionView);

const Component = TranslatedComponent;

export default Component;
